import React from "react";
import "./style.css";

export default function PageContent({children}) {
  return (
    <section className="page-content">
      {children}
    </section>
  );
}